import React, { Component } from "react";
import axios from "axios";
import {
  Segment,
  Header,
  Icon,
  Message,
  Accordion,
  Loader,
} from "semantic-ui-react";
import ContractOverview from "./ContractOverview";
import ContractFinalize from "./ContractFinalize";
import { ImageReupload } from "./ImageReupload";

import "./index.scss";

const baseUrl = "dealer";

class ContractManagement extends Component {
  state = {
    loading: true,
    renterName: "",
    activeIndex: -1,
    error: null,
    status: null,
    queue_status: null,
    systems: [],
    completed_at_formatted: null,
    submitted_at_formatted: null,
    selfOrdering: false,
    rejectedImages: [],
    dealerPayoutSystems: [],
    dealerPayoutTotal: "",
    dealerPayoutAdditionalMaterials: "",
  };

  componentDidMount = () => {
    this.fetchContract();
  };

  handleAccordionClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  fetchContract = () => {
    const { id } = this.props;
    this.setState({ loading: true });
    axios
      .get(`/contracts/${id}/`)
      .then(({ data }) => {
        const renter = data.renter;

        let images = [
          { name: "voided_check", ...data.voided_check_image },
          { name: "renter_dl", ...data.drivers_license_image },
          { name: "renter_poi", ...data.proof_of_income_image },
          { name: "renter_por", ...data.proof_of_residence_image },
        ];

        if (data.corenter) {
          images.push(
            { name: "corenter_dl", ...data.corenter.drivers_license_image },
            { name: "corenter_poi", ...data.corenter.proof_of_income_image },
            { name: "corenter_por", ...data.corenter.proof_of_residence_image }
          );
        }

        if (data.signed_ach_authorization_image) {
          images.push({
            name: "signed_ach",
            ...data.signed_ach_authorization_image,
          });
        }

        if (data.bill_of_sale) {
          images.push({
            name: "bill_of_sale",
            ...data.bill_of_sale,
          });
        }

        if (data.hvac_systems) {
          data.hvac_systems.forEach((s, i) => {
            if (s.registration_certificate_images.length) {
              images.push({
                name: `Registration Certificate for ${s.name}`,
                extra: "registration_cert",
                system_id: s.id,
                ...s.registration_certificate_images[0],
              });
            }
          });
        }

        images = images.filter(
          (i) =>
            !i.accepted &&
            i.rejection_notes &&
            i.rejection_notes.length > 0 &&
            i.rejection_notes.find((f) => !f.fixed) &&
            !i.new_image
        );

        this.setState({
          loading: false,
          status: data.status,
          coRenterId: data.corenter ? data.corenter.id : null,
          renterId: renter.id,
          renterName: `${renter.first_name} ${renter.last_name}`,
          queue_status: data.queue_status,
          systems: data.hvac_systems,
          completed_at_formatted: data.completed_at_formatted
            ? data.completed_at_formatted
            : null,
          submitted_at_formatted: data.submitted_at_formatted,
          signedAch: data.signed_ach_authorization_image
            ? data.signed_ach_authorization_image
            : null,
          billOfSale: data.bill_of_sale ? data.bill_of_sale : null,
          selfOrdering: data.dealer.self_ordering,
          rejectedImages: images,
          dealerPayoutTotal: data.dealer_payout_preview.total
            ? data.dealer_payout_preview.total
            : "0",
          dealerPayoutAdditionalMaterials: data.dealer_payout_preview
            .additional_materials
            ? data.dealer_payout_preview.additional_materials
            : "",
          dealerPayoutSystems:
            data.dealer_payout_preview &&
            data.dealer_payout_preview.hvac_systems
              ? data.dealer_payout_preview.hvac_systems
              : [],
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error: {
            message: err.response.data.ui_message,
          },
        });
      });
  };

  onFinalize = () => {
    this.fetchContract();
  };

  render() {
    const {
      loading,
      status,
      queue_status,
      completed_at_formatted,
      submitted_at_formatted,
      activeIndex,
      error,
      systems,
      renterName,
    } = this.state;

    const { id } = this.props;

    // QUEUE_STATUSES = { 0 => 'in review', 1 => 'ready', 2 => 'scheduled', 3 => 'installed', 4 => 'complete', 5 => 'ordered', 6 => 'bill of sale uploaded' }

    const content = () => {
      if (!queue_status) {
        switch (status) {
          case "1":
            return (
              <div>
                <Header>
                  <Header.Content>
                    <Icon color="blue" name="clock" />
                    This contract was submitted on {submitted_at_formatted} and
                    is in review. No further action is necessary.
                  </Header.Content>
                </Header>
                <p>You may view the contract below.</p>
              </div>
            );
            break;
          case "2":
            break;
          case "3":
            return (
              <div>
                <Header>
                  <Header.Content>
                    <Icon color="red" name="remove" />
                    This contract has been denied.
                  </Header.Content>
                </Header>
                <p>
                  No futher action may be taken on this contract. You may view
                  the contract below.
                </p>
              </div>
            );
            break;
          case "4":
            break;
          default:
            return null;
        }
      }

      switch (queue_status) {
        case 1:
          return (
            <Message
              positive
              header="Ordering"
              content="We're ordering the system(s) for your install..."
              icon="clock"
            />
          );
        case 3:
          return (
            <ContractFinalize
              contractId={id}
              onFinalize={this.onFinalize}
              billOfSale={this.state.billOfSale}
              signedAch={this.state.signedAch}
              selfOrdering={this.state.selfOrdering}
              systems={systems}
              dealerPayoutSystems={this.state.dealerPayoutSystems}
              dealerPayoutAdditionalMaterials={
                this.state.dealerPayoutAdditionalMaterials
              }
              dealerPayoutTotal={this.state.dealerPayoutTotal}
            />
          );
        case 4:
          return (
            <Message
              positive
              header="Documents Approved"
              content="We're registering the system extended warranty"
              icon="clock"
            />
          );
        case 5:
          return (
            <div>
              <Header>
                <Header.Content>
                  <Icon color="green" name="check" />
                  This contract is complete.
                </Header.Content>
              </Header>
              <p>
                This contract was completed on <b>{completed_at_formatted}</b>.
              </p>
              <p>
                No futher action may be taken on this contract. You may view the
                contract below.
              </p>
            </div>
          );
        case 6:
          return (
            <ImageReupload
              contractId={id}
              fetchContract={this.fetchContract}
              images={this.state.rejectedImages}
              renterId={this.state.renterId}
              coRenterId={this.state.coRenterId}
            />
          );
        case 7:
          return (
            <Message
              positive
              header="Payment Disbursement"
              content="Waiting on payment disbursement"
              icon="clock"
            />
          );
        case 8:
          return (
            <ContractFinalize
              contractId={id}
              onFinalize={this.onFinalize}
              billOfSale={this.state.billOfSale}
              signedAch={this.state.signedAch}
              selfOrdering={this.state.selfOrdering}
              systems={systems}
            />
          );
        default:
          return null;
      }
    };

    if (error) {
      return <Message negative header="Error" content={error.message} />;
    }

    if (loading) {
      return <Loader active content="Loading Contract..." />;
    }

    if (!loading) {
      return (
        <div>
          <Segment loading={loading}>
            <Header
              as="h1"
              content="Contract Management"
              dividing
              subheader={`Renter: ${renterName}`}
            />
            {content()}
          </Segment>
          <Segment>
            <Accordion>
              <Accordion.Title
                active={activeIndex === 0}
                index={0}
                content="Contract Details"
                onClick={this.handleAccordionClick}
              />
              <Accordion.Content active={activeIndex === 0}>
                <ContractOverview contractId={id} />
              </Accordion.Content>
            </Accordion>
          </Segment>
        </div>
      );
    }
  }
}

export default ContractManagement;
